export const i18nBusiness = {
  model_type: {
    pdm: 'pdm',
    condition_based: 'Condition based',
    regression: 'Regression',
  },
  model_view: {
    title: 'Visualização dos modelos',
    high: 'Alto',
    medium: 'Médio',
    good: 'Bom',
  },
  alarm: {
    status: {
      anomaly_detected: 'Anomalia detectada',
      risk_of_failure: 'Risco de falha',
      under_investigation: 'Em análise',
      closed: 'Fechado',
    },
    classification: {
      need_intervention: 'Intervenção necessária',
      no_action_needed: 'Nenhuma ação necessária',
      inappropriate_limits: 'Limites inapropriados',
      instrumentation_problem: 'Problema de instrumentação',
      others: 'Outro',
      real_alarm: 'Alarme real',
      false_alarm: 'Alarme falso',
      useful: 'Útil',
      not_useful: 'Não útil',
    },
    action: {
      none: 'Nenhuma',
      cleaning: 'Limpeza',
      repair: 'Conserto ou ajuste pontual',
      machine_restart: 'Reinicialização',
      parameters_adjustments: 'Mudança de parâmetros',
      parts_replacement: 'Troca de peças',
      others: 'Outros (informe nos detalhes)',
    },
    reason: {
      process_instability: 'Instabilidade do processo',
      resumption_production: 'Retomada de produção',
      instrumentation_problem: 'Erro de instrumento',
      process_change: 'Mudança de processo',
      tests_in_progress: 'Testes em andamento',
      not_sure: 'Não há certeza',
      insufficient_time: 'Tempo insuficiente',
      action_not_effective: 'Ação não efetiva',
      inappropriate_limits: 'Limites inapropriados',
      uncalibrated_model: 'Modelo descalibrado',
      others: 'Outros',
    },
  },
  sensor: {
    status: {
      active: { active: 'ativo', active_one: 'ativo', active_other: 'ativos' },
      delayed: { delayed: 'atrasado', delayed_one: 'atrasado', delayed_other: 'atrasados' },
      no_data: { no_data: 'sem dados', no_data_one: 'sem dado', no_data_other: 'sem dados' },
      offline: { offline: 'offline', offline_one: 'offline', offline_other: 'offlines' },
    },
  },
  pump_curve: {
    kpi: {
      power_calculated: 'Potência calculada',
      power_expected: 'Potência esperada',
      density: 'Densidade',
      efficiency: 'Eficiência',
      efficiency_expected: 'Eficiência esperada',
      rotation: 'Rotação',
      flow_rate: 'Vazão',
      pressure_discharge: 'Pressão',
      box_level: 'Nível da caixa',
      npsha: 'NPSHa',
      npshr: 'NPSHr',
    },
  },
};
